import {
  ITheme, SurveyModel,
} from 'survey-core';
import { COLORS } from './theme';
import {
  SurveyColors, SurveySettings, SurveyTheme,
} from '../types';
import './styles.css';

const getSurveyColors = (theme: SurveyTheme): SurveyColors => {
  return {
    header: theme.colors?.header ?? '#FFF',
    sidebar: theme.colors?.sidebar ?? COLORS.primary,
  };
};

const getSurveyTheme = (settings: SurveySettings): ITheme => {
  const colors = getSurveyColors(settings.theme);
  return {
    themeName: 'default',
    cssVariables: {
      '--sjs-header-backcolor': colors.header,
      '--sjs-primary-backcolor': COLORS.primary,
      '--sjs-primary-backcolor-dark': COLORS.primaryDark,
    },
    header: {
      logoPositionX: 'center',
      titlePositionX: 'center',
      descriptionPositionX: 'center',
      ...settings.survey?.header ?? {},
    },
    headerView: settings.survey?.headerView ?? 'basic',
    ...settings.surveysTheme,
  };
};

export const applySurveyTheme = (survey: SurveyModel, settings: SurveySettings): void => {
  const theme = getSurveyTheme(settings);
  survey.applyTheme(theme);
  survey.logo = settings.theme?.logoUrl;
  survey.maxWidth = '1600px';
  survey.questionErrorLocation = 'bottom';
};
